import { gql } from "@apollo/client";
export const GET_ALL_TEAMS_AND_USERS = gql`
  query GetAllTeamsAndUsers($input: getAllTeamsAndUsersInput) {
    getAllTeamsAndUsers(input: $input) {
      status
      message
      data
    }
  }
`;

export const GET_TEAMS_WITH_UNREAD_COUNT = gql`
  query GetTeamsWithUnreadCounts {
    getTeamsWithUnreadCounts {
      id
      name
      members {
        id
        name
        email
        unreadCount
      }
    }
  }
`;

export const GET_TEAMS = gql`
  query GetTeams {
    getTeams {
      id
      name
      description
      modifiedAt
      createdAt
    }
  }
`;

export const GET_BG_ACCOUNT_BY_ID = gql`
  query GetBgAccountById {
    getBgAccountById {
      id
      organization
      location
      teamSize
      companySize
      industry
      logo
      registeredAddress
      typeOfCompany
      dateOfIncorporation
      businessContactNumber
      CIN
      PAN
      TAN
      GSTIN
    }
  }
`;

export const GET_INTERNAL_CHAT_ID = gql`
  query GetInternalChatId($input: internalChatIdInput!) {
    getInternalChatId(input: $input) {
      status
      message
      data
    }
  }
`;

export const GET_USERS = gql`
  query GetUsers {
    users {
      id
      name
      email
      status
      UserRole {
        roleId
        userId
        role {
          roleName
        }
      }
    }
  }
`;

export const GET_USER_BY_ID = gql`
  query GetUserById {
    getUserById {
      id
      name
      email
      status
      contactNumber
      Designation
      Department
      emailVerified
      onboardingDone
      UserRole {
        roleId
        userId
      }
      franchiseId
      teamId
    }
  }
`;

export const GET_ALL_APPLICATION_IDS = gql`
  query AllApplicationId($input: AllApplicationIdInput) {
    allApplicationId(input: $input) {
      id
      bgAccountId
      appIDString
      appName
      startDate
      endDate
    }
  }
`;

export const GET_GRAPH_ANALYTICS = gql`
  query GraphAnalytics($input: GetBotAnalyticsInputs) {
    graphAnalytics(input: $input) {
      graphData
    }
  }
`;

export const GET_BOT_ANALYTICS = gql`
  query BotAnalytics {
    botAnalytics {
      status
      message
      data
    }
  }
`;

export const GET_BG_ACCOUNT_BY_BG_ID = gql`
  query GetBgAccountById {
    getBgAccountById {
      id
    }
  }
`;

export const GET_CURRENT_PLAN_AND_BILLING_DETAILS_BY_BG_ACCOUNT = gql`
  query GetcurrentPlanAndBillingDetailsByBgAccount(
    $input: getCurrentPlanAndBillingDetailsInput
  ) {
    getcurrentPlanAndBillingDetailsByBgAccount(input: $input) {
      clientPackageId
      bgAccountId
      packageFeatureId
      status
      startDate
      endDate
      client {
        id
        users {
          name
          id
          email
          contactNumber
          UserRole {
            userId
            roleId
          }
        }
      }
      package {
        package {
          packageId
          packageName
          packageDescriptions
          packageAmount
          packageCategory
          packageTypeId
          packageDuration
          packageExpiryDate
          permissions
        }
        feature {
          featuresId
          numberOfBots
          dashboardAccess
          sessionsLimit
          uniqueEndUsers
          additionalConversationCost
          supportUsers
          reportingAnalytics
          language
          CRMIntegration
          additionalChannelntegration
          Intents
          paymentIntegration
          mapIntegraionAPI
          dataSecurity
          conversationHistory
          thirdPartyIntegration
          callToAction
          exportsLeads
          exportReport
          templateCustomization
          emailAndCallSupport
          leadGenerationForm
          multipleChatWindowsForLive_ChatPerUser
          ticketHistory
          blockUser
          visitorInsight
          preDefinedResponses
          liveChat
          whiteLabelRemoveBranding
          fileUploads
          additionalIntegrationPerWebsiteSameBot
          askingPrice
        }
      }
    }
  }
`;

export const GET_CHAT_ROOM_META_BY_CHATROOM_ID = gql`
  query ChatRoomMetaByChatRoomId($input: ChatRoomIdInput!) {
    chatRoomMetaByChatRoomId(input: $input) {
      id
      name
      value
    }
  }
`;

export const GET_SESSIONS_BY_CHAT_ROOM_ID = gql`
  query SessionsByChatRoomId($input: ChatRoomIdInput!) {
    sessionsByChatRoomId(input: $input) {
      id
      chatRoomId
      assignedAgentId
      startDate
      endDate
      botName
      messageRequest {
        id
        sessionId
        content
        inputType
        prevRequestId
        templateId
        intentId
        time
      }
      agentName
    }
  }
`;
export const GET_ALL_MAPS = gql`
  query GetallMaps {
    getallMaps {
      id
      bgAccountId
      services
      configName
      value
    }
  }
`;

export const GET_CHAT_ROOMS = gql`
  query ChatRooms($input: GetAllChatRoomsFilterInput) {
    chatRooms(input: $input) {
      status
      message
      data
    }
  }
`;

export const GET_SESSION_BY_BG_ACCOUNT_ID = gql`
  query GetSessionByBgaccountId($input: getSessionByBgaccountIdInput!) {
    getSessionByBgaccountId(input: $input) {
      id
      chatRoomId
      assignedAgentId
      connectionId
      timedOut
      createdAt
      modifiedAt
      deletedAt
      startDate
      endDate
      reslovedBy
      chatRoom {
        chatName {
          time
          agentId
          applicationId
        }
      }
      botName
      agentName
    }
  }
`;
